import { useState } from "react";
import styles from "./FAQ.module.css";

const faqs = [
  {
    question: "How do I make a reservation?",
    answer:
      "You can book directly through our website by selecting your preferred residence, choosing your dates, and completing the payment process.",
  },
  {
    question: "Can I modify or cancel my booking?",
    answer:
      "Yes, modifications and cancellations can be made from your booking dashboard. Please refer to our cancellation policy for more details.",
  },
  {
    question: "What payment methods do you accept?",
    answer: "We accept credit/debit cards, PayPal, and bank transfers.",
  },
  {
    question: "Are there any hidden fees?",
    answer: "No, the price you see is the final price. We value transparency.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (index) => {
    setActiveIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <div className={styles.faqSection}>
      <div className={styles.faqWrapper}>
        <h1 className={styles.faqTitle}>FAQs</h1>
        {faqs.map((faq, index) => (
          <div key={index} className={styles.faqItem}>
            <div className={styles.faqQuestionRow} onClick={() => toggle(index)}>
              <h3 className={styles.faqQuestion}>{faq.question}</h3>
              <span className={styles.faqIcon}>
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            {activeIndex === index && (
              <p className={styles.faqAnswer}>{faq.answer}</p>
            )}
            <div className={styles.faqDivider}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
